import { render, staticRenderFns } from "./ChargebackList.vue?vue&type=template&id=4070e994&scoped=true&"
import script from "./ChargebackList.vue?vue&type=script&lang=js&"
export * from "./ChargebackList.vue?vue&type=script&lang=js&"
import style0 from "./ChargebackList.vue?vue&type=style&index=0&id=4070e994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4070e994",
  null
  
)

export default component.exports